const validateStatus = [
  {
    id: 0,
    name: '普通用户'
  },
  {
    id: 1,
    name: '内部用户'
  },
  {
    id: 10,
    name: '家慧库会员'
  },
  {
    id: 11,
    name: '企业内部群主'
  },
  {
    id: 12,
    name: '大家长'
  },
  {
    id: 15,
    name: '省中心' //省中心
  },
  {
    id: 18,
    name: '企业群主'
  },
  {
    id: 19,
    name: '企业群主兼老师'
  },
  {
    id: 20,
    name: '区域合伙人' //区域合伙人
  },
  {
    id: 21,
    name: '城市合伙人' //城市合伙人
  },
  {
    id: 22,
    name: '行业合伙人' //行业合伙人
  }
]

export default validateStatus
